import React, { useEffect } from 'react';
import { motion } from 'framer-motion';
import { ArrowLeftIcon } from 'lucide-react';
interface TermsPageProps {
  onBack: () => void;
}
export function TermsPage({
  onBack
}: TermsPageProps) {
  useEffect(() => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  }, []);
  return <div className="min-h-screen w-full bg-dark-bg font-inter antialiased" data-id="element-523">
      <div className="max-w-3xl mx-auto px-6 py-16 md:py-24" data-id="element-524">
        {/* Back button */}
        <motion.button onClick={onBack} className="inline-flex items-center gap-2 text-concrete/60 hover:text-orange-accent transition-colors duration-200 mb-12 font-inter text-sm" initial={{
        opacity: 0,
        x: -10
      }} animate={{
        opacity: 1,
        x: 0
      }} transition={{
        duration: 0.3
      }} data-id="element-525">
          <ArrowLeftIcon className="w-4 h-4" data-id="element-526" />
          Back to main page
        </motion.button>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.5
      }} data-id="element-527">
          <h1 className="font-bebas text-4xl md:text-5xl text-white tracking-wide mb-2" data-id="element-528">
            TERMS OF <span className="text-orange-accent" data-id="element-529">SERVICE</span>
          </h1>
          <p className="font-inter text-concrete/60 text-sm mb-12" data-id="element-530">
            Last updated:{' '}
            {new Date().toLocaleDateString('en-US', {
            year: 'numeric',
            month: 'long',
            day: 'numeric'
          })}
          </p>

          <div className="space-y-10 font-inter text-concrete leading-relaxed" data-id="element-531">
            <section data-id="element-532">
              <h2 className="font-bebas text-2xl text-white tracking-wide mb-3" data-id="element-533">
                1. ACCEPTANCE OF TERMS
              </h2>
              <p data-id="element-534">
                By purchasing and accessing the Concrete Bunker Blueprint ("the
                Product"), you agree to be bound by these Terms of Service. If
                you do not agree to these terms, do not purchase or use the
                Product. These terms constitute a legally binding agreement
                between you and Concrete Bunker Blueprint.
              </p>
            </section>

            <section data-id="element-535">
              <h2 className="font-bebas text-2xl text-white tracking-wide mb-3" data-id="element-536">
                2. PRODUCT DESCRIPTION
              </h2>
              <p className="mb-3" data-id="element-537">
                The Concrete Bunker Blueprint is a digital informational guide
                delivered as a downloadable document. The Product provides
                educational and instructional content related to residential
                storage construction methods. Upon purchase, you will receive
                immediate digital access to the complete guide.
              </p>
              <p data-id="element-538">
                No physical product will be shipped. No account creation is
                required to access your purchase.
              </p>
            </section>

            <section data-id="element-539">
              <h2 className="font-bebas text-2xl text-white tracking-wide mb-3" data-id="element-540">
                3. LICENSE & PERMITTED USE
              </h2>
              <p className="mb-3" data-id="element-541">
                Upon purchase, you are granted a single-user, non-transferable,
                non-exclusive license to use the Product for your personal,
                non-commercial purposes. You may:
              </p>
              <ul className="list-none space-y-2 pl-4 mb-3" data-id="element-542">
                <li className="flex gap-2" data-id="element-543">
                  <span className="text-orange-accent" data-id="element-544">—</span> Download and
                  store the guide on your personal devices
                </li>
                <li className="flex gap-2" data-id="element-545">
                  <span className="text-orange-accent" data-id="element-546">—</span> Print a single
                  copy for personal reference
                </li>
                <li className="flex gap-2" data-id="element-547">
                  <span className="text-orange-accent" data-id="element-548">—</span> Use the methods
                  described for personal residential projects
                </li>
              </ul>
              <p data-id="element-549">
                You may NOT reproduce, distribute, resell, share, or publish any
                portion of this Product without express written permission.
              </p>
            </section>

            <section data-id="element-550">
              <h2 className="font-bebas text-2xl text-white tracking-wide mb-3" data-id="element-551">
                4. DISCLAIMER OF WARRANTIES
              </h2>
              <p className="mb-3" data-id="element-552">
                The Product is provided "as is" for informational and
                educational purposes only. We make no warranties, express or
                implied, regarding:
              </p>
              <ul className="list-none space-y-2 pl-4 mb-3" data-id="element-553">
                <li className="flex gap-2" data-id="element-554">
                  <span className="text-orange-accent" data-id="element-555">—</span> The suitability
                  of methods for your specific home or construction type
                </li>
                <li className="flex gap-2" data-id="element-556">
                  <span className="text-orange-accent" data-id="element-557">—</span> Compliance with
                  local building codes, zoning laws, or regulations
                </li>
                <li className="flex gap-2" data-id="element-558">
                  <span className="text-orange-accent" data-id="element-559">—</span> Results achieved
                  by following the instructions
                </li>
                <li className="flex gap-2" data-id="element-560">
                  <span className="text-orange-accent" data-id="element-561">—</span> The accuracy of
                  cost estimates, which may vary by region and market conditions
                </li>
              </ul>
              <p data-id="element-562">
                You are solely responsible for verifying that any construction
                activity complies with applicable local, state, and federal
                laws.
              </p>
            </section>

            <section data-id="element-563">
              <h2 className="font-bebas text-2xl text-white tracking-wide mb-3" data-id="element-564">
                5. LIMITATION OF LIABILITY
              </h2>
              <p data-id="element-565">
                To the maximum extent permitted by law, Concrete Bunker
                Blueprint and its authors shall not be liable for any direct,
                indirect, incidental, consequential, or punitive damages arising
                from your use of or inability to use the Product, including but
                not limited to property damage, personal injury, legal
                consequences, or financial loss resulting from construction
                activities undertaken based on this guide.
              </p>
            </section>

            <section data-id="element-566">
              <h2 className="font-bebas text-2xl text-white tracking-wide mb-3" data-id="element-567">
                6. REFUND POLICY
              </h2>
              <p data-id="element-568">
                We offer a 60-day money-back guarantee. If you are not satisfied
                with the Product for any reason within 60 days of purchase,
                contact us for a full refund. Refunds are processed within 24
                business hours. No explanation is required. After 60 days, all
                sales are final.
              </p>
            </section>

            <section data-id="element-569">
              <h2 className="font-bebas text-2xl text-white tracking-wide mb-3" data-id="element-570">
                7. LEGAL COMPLIANCE
              </h2>
              <p data-id="element-571">
                The construction methods described in this guide are intended
                for lawful use on property you own or have legal authority to
                modify. You are solely responsible for ensuring that your use of
                this information complies with all applicable federal, state,
                and local laws, including but not limited to firearms storage
                regulations, building codes, and homeowner association rules.
              </p>
            </section>

            <section data-id="element-572">
              <h2 className="font-bebas text-2xl text-white tracking-wide mb-3" data-id="element-573">
                8. MODIFICATIONS TO TERMS
              </h2>
              <p data-id="element-574">
                We reserve the right to modify these Terms at any time.
                Continued use of the Product following any changes constitutes
                acceptance of the revised Terms. We encourage you to review
                these Terms periodically.
              </p>
            </section>

            <section data-id="element-575">
              <h2 className="font-bebas text-2xl text-white tracking-wide mb-3" data-id="element-576">
                9. GOVERNING LAW
              </h2>
              <p data-id="element-577">
                These Terms shall be governed by and construed in accordance
                with the laws of the United States. Any disputes arising under
                these Terms shall be resolved through binding arbitration.
              </p>
            </section>

            <section data-id="element-578">
              <h2 className="font-bebas text-2xl text-white tracking-wide mb-3" data-id="element-579">
                10. CONTACT
              </h2>
              <p data-id="element-580">
                For questions regarding these Terms or to request a refund,
                contact us at:{' '}
                <span className="text-orange-accent" data-id="element-581">
                  support@concretebunkerblueprint.com
                </span>
              </p>
            </section>
          </div>
        </motion.div>

        {/* Back button bottom */}
        <motion.button onClick={onBack} className="inline-flex items-center gap-2 text-concrete/60 hover:text-orange-accent transition-colors duration-200 mt-16 font-inter text-sm" initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} transition={{
        duration: 0.5,
        delay: 0.3
      }} data-id="element-582">
          <ArrowLeftIcon className="w-4 h-4" data-id="element-583" />
          Back to main page
        </motion.button>
      </div>
    </div>;
}